export const getPageInfo = ( state) => {
    return state.all
}